// Respostas do checkout simplificado fixadas pelo produto de doacao escolhido.
// Uma opcao de pergunta-pai e "fixada por produto" quando, em toda pergunta dependente,
// ela tem uma unica opcao filha com o mesmo nome (ex.: Regional "REDE DO BEM" ->
// Comite "REDE DO BEM"). Se o nome do produto contem essa opcao, pai e filha ficam fixados.
// Mesma regra do back-end (auc.Helper/ProductFixedAnswersHelper.cs).

const normalize = (text) =>
  (text || "").trim().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

const isWordChar = (char) => !!char && /[a-z0-9]/.test(char);

function containsPhrase(text, phrase) {
  let index = text.indexOf(phrase);
  while (index >= 0) {
    const end = index + phrase.length;
    if (!isWordChar(text[index - 1]) && !isWordChar(text[end])) return true;
    index = text.indexOf(phrase, index + 1);
  }
  return false;
}

// Opcoes de pergunta-pai que funcionam como "balde" fixado por produto.
function bucketOptions(questions) {
  const buckets = [];
  (questions || []).forEach((parent) => {
    const dependents = questions.filter((q) => q.relationWithQuestionId === parent.id);
    if (!dependents.length) return;
    (parent.options || []).forEach((option) => {
      const description = normalize(option.description);
      if (!description) return;
      const children = dependents.map((question) => ({
        question,
        options: (question.options || []).filter((o) => o.relationWithOptionId === option.id),
      }));
      const isBucket = children.every(
        (c) => c.options.length === 1 && normalize(c.options[0].description) === description
      );
      if (isBucket) buckets.push({ parent, option, children });
    });
  });
  return buckets;
}

export function bucketOptionIds(questions) {
  return new Set(bucketOptions(questions).map((b) => b.option.id));
}

// Retorna { [responseNumber]: resposta } para o produto informado.
export function resolveProductFixedAnswers(questions, donationProductName) {
  const result = {};
  const productName = normalize(donationProductName);
  if (!productName) return result;

  bucketOptions(questions).forEach(({ parent, option, children }) => {
    if (!containsPhrase(productName, normalize(option.description))) return;
    result[parent.responseNumber] = option.description;
    children.forEach((c) => {
      result[c.question.responseNumber] = c.options[0].description;
    });
  });
  return result;
}
